<template>
  <validation-observer
    v-if="!isAdditional && isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      id="email"
      :validated="formObserver.validated && observer.failed"
      v-bind="observer"
    >
      <form-row :label="title || 'Email address'">
        <help-text
          v-if="!isColumnLayout && !!helpText"
          :error="formObserver.validated && !observer.valid"
        >
          <p
            v-html="helpText"
          />
        </help-text>
        <validation-provider
          v-slot="{ errors }"
          rules="email"
          name="Email"
          :vid="`${stepId}_email`"
          :data-unit-test="`${stepId}_email`"
        >
          <qz-text-field
            v-model="questionData.email"
            :data-test="fieldTrackerId"
            :class="!isColumnLayout && 'mt-6'"
            type="email"
            autocomplete="email"
            :error="!!suggestedEmail"
            :error-messages="errors"
            :maxlength="inputCharsLimiters.EMAIL"
            @keyup="helpers.limitInputChars(questionData, 'email', inputCharsLimiters.EMAIL)"
          />
          <div
            v-if="suggestedEmail && !errors.length"
            class="mt-2 ml-3 text-caption"
          >
            <a
              class="red--text text-decoration-underline"
              @click.prevent="applySuggestion"
            >
              Did you mean: {{ suggestedEmail }}?
            </a>
          </div>
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from './Base';
import { snakeCase } from 'lodash';

export default {
  name: 'question-email',
  extends: QuestionBase,
  data () {
    return {
      fields: ['email'],
    };
  },
  computed: {
    suggestedEmail () {
      return this.helpers.suggestedEmail(this.questionData[this.questionFields.email]);
    },
    fieldTrackerId () {
      return snakeCase(this.questionFields.email);
    },
  },
  methods: {
    applySuggestion () {
      this.questionData[this.questionFields.email] = this.suggestedEmail;
    },
  },
};
</script>
